<template>
    <vue-apex-charts height="100" :options="options" :series="series"></vue-apex-charts>
</template>

<script>
import VueApexCharts from 'vue-apexcharts' 
export default {
    props:{
        prices:{
            type:Array,
            default:()=>[]
        },
    },
    components:{
        VueApexCharts
    },
    data(){
        return {
            
        }
    },
    computed:{
        series(){
            return [{
                name: 'Fiyat Geçmişi',
                data: this.prices.map(p => parseFloat(p.Price.replace(',','.'))).reverse()
            }]
        },
        options(){
            let prices = this.prices.map(p => parseFloat(p.Price.replace(',','.')))
            let min = Math.min(...prices)
            let max = Math.max(...prices)
            let avg = prices.reduce((sum,p)=>{ sum = sum + p; return sum },0) / prices.length

            let lastPrice = this.prices.find(p=> p.IsLastUpdated)?.Price?.replace(',','.') || 0
            let color = lastPrice != 0 ? lastPrice < avg ? '#FF2442' : '#36AE7C' : '#1e1e1e'

            return{
                chart: {
                    type: 'area',
                    height: 100,
                    sparkline:{
                        enabled:true
                    }
                },
                colors:[color],
                fill:{
                    type:'gradient',
                    gradient:{
                        enabled:true,
                        opacityFrom: 0.55,
                        opacityTo: 0
                    }
                },
                annotations:{
                    yaxis:[{
                        y: avg,
                        strokeDashArray: 5,
                        borderColor: '#22292f',
                    }]
                },
                yaxis:{  
                    show:false,
                    min:min - 5,
                    max:max + 5
                },
                tooltip:{ enabled:false },
            }
        }
    }
}
</script>

<style>

</style>